import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import bs from '../../static/images/bs-logo.png';
import jq from '../../static/images/jquery-logo.png';
import html from '../../static/images/html-logo.png';
import css from '../../static/images/css-logo.png';
import csharp from '../../static/images/csharp-logo.png';
import wp from '../../static/images/wp-logo.png';
import along from '../../static/images/web/along.JPG';
import bn from '../../static/images/web/bn.JPG';
import hh from '../../static/images/web/haulagehub.JPG';
import ile from '../../static/images/web/ile.JPG';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        width: 500,
        padding: "20px",
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
    },
    titleBar: {
        background:
            'linear-gradient(to top, rgba(0,0,0,0.7) 0%, ' +
            'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    icon: {
        color: 'white',
    },
    media: {
        height: 140,
    },
}));

const tileData = [
    {
        img: along,
        title: 'Along',
        author: 'author',
        featured: true,
        tools: [{tool: jq, title: "JQuery"}, {tool: html, title: "HTML"}, {tool: css, title: "CSS"}],
        details: 'A web application for a rideshare company in Abuja, designed using HTML, CSS and jQuery',
        link: 'http://along.ng/'
    },
    {
        img: hh,
        title: 'Haulage Hub',
        author: 'author',
        tools: [{tool: html, title: "HTML"}, {tool: css, title: "CSS"}, {tool: csharp, title: "CSharp"}],
        details: 'A web application for a truck delivery company in Nigeria, designed using HTML, CSS, ASPNET',
        link: 'http://www.thehaulagehub.com/'
    },
    {
        img: bn,
        title: 'Bookings Nigeria',
        author: 'author',
        tools: [{tool: html, title: "HTML"}, {tool: bs, title: "BootStrap"}, {tool: jq, title: "jQuery"}],
        details: 'A mobile view of a web application for a travel company designed HTML, BootStrap, and jQuery',
        link: 'https://bookingsnigeria.com/'
    },
    {
        img: ile,
        title: 'Ile',
        author: 'author',
        featured: true,
        tools: [{tool: html, title: "HTML"}, {tool: wp, title: "WordPress"}],
        details: 'A web application for a property listing company in Nigeria designed using WordPress',
        link: 'https://iile.com.ng/'
    },
];

export default function FullStack() {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("sm"));
    const sz = () => {
        if(!matches) {
            return 2;
        }

        return 1;
    }

    return (
        <div className={classes.root}>
            <GridList cellHeight={"auto"} spacing={1} className={classes.gridList}>
                {tileData.map((tile) => (
                    <GridListTile key={tile.img} cols={tile.featured ? 2 : sz()} rows={tile.featured ? 2 : sz()}>
                        <Box mt={3} p={1}>
                            <Card >
                                <CardActionArea>
                                    <CardMedia
                                        className={classes.media}
                                        image={tile.img}
                                        title={tile.title}
                                        component="img"
                                    />
                                    <CardContent>
                                        <Typography gutterBottom variant="h5" component="h2">
                                            {tile.title}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary" component="p">
                                            {tile.details}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                                <CardActions>
                                    {tile.tools.map((key) => (
                                        < IconButton key = { key.title } aria-label= "studio" >
                                        <img src={key.tool} width="25px" alt={key.title} />
                                        </IconButton>
                                    ))}
                                </CardActions>
                            </Card>
                        </Box>
                    </GridListTile>
                ))}
            </GridList>
        </div>
    );
}